import { Link } from 'react-router-dom';

import './SiteFooter.css';

export default function SiteFooter() {
	return (
		<footer className="site-footer">
			<div className="site-footer__inner app-container">
				<nav className="site-footer__links">
					<Link to="/">Home</Link>
					<a href="https://www.privacypolicygenerator.info/live.php?token=wmuXmxP61pJIJxIZW6lFd7cqa1q1NLsG">
						Privacy Policy
					</a>
				</nav>
				<p className="site-footer__note">
					Made with <span aria-hidden="true">♥</span>
					<span className="visually-hidden">love</span> · Got feedback?{' '}
					<a href="mailto:contact@fantasynutmeg.com">Drop an email</a>
				</p>
			</div>
		</footer>
	);
}
